export const P150ErrorPage = () => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                textAlign: 'center',
                padding: '2rem',
            }}
        >
            <h1 style={{ fontSize: '3rem', color: '#d32f2f', marginBottom: '1rem' }}>
                Intern fejl
            </h1>
            <p style={{ fontSize: '1.25rem', marginBottom: '2rem', color: '#333' }}>
                Der er desværre sket en fejl på siden.
            </p>
            <a
                href="/"
                style={{
                    fontSize: '1rem',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#231F20',
                    color: '#fff',
                    textDecoration: 'none',
                    borderRadius: '4px',
                }}
            >
                Gå til forsiden
            </a>
        </div>
    );
};
